var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("" + _vm.cssPrefix),
    'sw-flexbox',
    'sw-flexbox--column',
    'sw-flexbox--center-justify',
    'sw-flexbox--center-items'
  ]},[_vm._v("\n  "+_vm._s(_vm.errorMessage  || 'Error In Widget Configurations')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }